import InternalMessagingTypes from "./internal-messaging.types";


export interface SelectConversation {
    id: string;
}

export interface NewMessage {
    content: string;
    user: string
    conversationId: string;
}

export type InternalMessagingAction =
    | { type: typeof InternalMessagingTypes.SELECT_CONVERSATION; payload: SelectConversation }
    | { type: typeof InternalMessagingTypes.NEW_MESSAGE_NOTIFICATION; payload: NewMessage }
    | { type: typeof InternalMessagingTypes.OPEN_PHONEBOOK; payload: boolean }

export function newMessage(
    content: string,
    user: string,
    conversationId: string
): InternalMessagingAction {
    return {
        type: InternalMessagingTypes.NEW_MESSAGE_NOTIFICATION,
        payload: {
            content,
            user,
            conversationId
        },
    };
}